import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Row, Col, Modal, Form, Button, OverlayTrigger } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { MdEdit, MdDelete, MdAddCircle, MdRemoveRedEye, MdExitToApp } from "react-icons/md";
import { Tooltip } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import { MdFilterList } from "react-icons/md";

import loading from "../../assets/images/common/loading.gif";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BsPatchCheckFill } from "react-icons/bs";
import AppDataGrid from '../../components/common/AppDataGrid';



const Students = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [form, setForm] = useState({
        student_id: "",
        student_first_name: "",
        student_last_name: "",
        date_of_exit: "",
        class_name: "",
        section_name: "",
        roll_no: "",
        admission_number: "",
        father_surname: "",
        father_firstname: "",
        mother_surname: "",
        mother_firstname: "",
        exit_type: "",
        document: "",
        exit_reason: "",
        exit_status: "",
        date_of_exit: "",
        comments: "",
        language_name: "",
    })

    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const handleClosePopupModal = () => setShowExitForm(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [users, setUsers] = useState([]);
    const [students, setStudents] = useState([]);
    const [academicYears, setAcademicYears] = useState([]);
    const [exitstudent, setExitStudent] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileNamesString, setFileNamesString] = useState("");
    const [uploadedFileNames, setUploadedFileNames] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "Director"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());

    const Roles = ["School Admin"];
    const Admin = !Roles.includes(userObj.role_name?.trim());


    const handleShowFilterModal = () => {
        if (classes.length === 0) {
            fetchDropdownData('/classes/', setClasses, userObj.school_id);
        }
        if (users.length === 0) {
            fetchUsers();
        }
        if (academicYears.length === 0) {
            fetchAcademicYears();
        }
        setShowFilterModal(true);
    }

    const fetchDropdownData = async (endpoint, setter, school_id) => {
        try {
            let action = 'READ';
            if (endpoint === "/Users/") {
                action = 'TREAD';
            }
            const payload = { action };

            if (school_id) {
                payload.school_id = school_id;
            }

            const response = await axios.post(baseUrl + endpoint, payload);
            setter(response.data);
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
        }
    };

    const fetchSections = async (class_id) => {
        try {
            const response = await axios.post(baseUrl + "/getsectionsbyteachersubjectmap/", {
                action: "SECTIONREAD",
                school_id: userObj.school_id,
                class_id: class_id,
                academic_year_id: userObj.academic_year_id
            });
            setSections(response.data);
        } catch (error) {
            console.error("Error fetching section:", error);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await axios.post(baseUrl + "/Users/", {
                action: "TREAD",
                school_id: userObj.school_id
            });
            setUsers(response.data);
        } catch (error) {
            console.error("Error fetching user:", error);
        }
    };

    const fetchStudents = async () => {
        try {
            const response = await axios.post(baseUrl + "/students/", {
                action: "FILTER", school_id: userObj.school_id,
                academic_year_id: userObj.academic_year_id
            });
            setStudents(response.data || []);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };

    const fetchAcademicYears = async () => {
        try {
            const response = await axios.post(baseUrl + "/AcademicYear/", {
                action: "DROPDOWNREAD",
                school_id: userObj.school_id,
            });

            const years = response.data || [];

            setAcademicYears(years);
            const defaultYearId = userObj.academic_year_id;
            if (defaultYearId && !filter.academic_year_id) {
                setFilter((prev) => ({
                    ...prev,
                    academic_year_id: defaultYearId,
                }));
            }
        } catch (error) {
            console.error("Error fetching academic years:", error);
        }
    };

    useEffect(() => {
        // fetchExitStudent();
        fetchStudentFeeSchedule();
    }, []);
    const fetchExitStudent = async () => {
        try {
            const response = await axios.post(baseUrl + "/exitstudent/", {
                action: "UPDATE", school_id: userObj.school_id
            });
            setExitStudent(response.data);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };


    const [studentFeeSchedule, setStudentFeeSchedule] = useState([]);
    const [feeDetail, setFeeDetail] = useState(null);
    const fetchStudentFeeSchedule = async (student_id) => {
        if (!student_id) return;
        try {
            const { data } = await axios.get(`${baseUrl}/main/getstudentfeedetail`, {
                params: {
                    _school_id: userObj.school_id,
                    _academic_year_id: userObj.academic_year_id,
                    _student_id: student_id,
                    user_id:userObj.user_id
                },
            });
            const root = Array.isArray(data) ? data[0] : data;
            const detail = root?.getstudentfeedetail || root;

            setFeeDetail(detail || null);
            setStudentFeeSchedule(detail?.schedules || []);
        } catch (err) {
            console.error("Error fetching fee schedule:", err);
            setFeeDetail(null);
            setStudentFeeSchedule([]);
        }
    };
    const handleInputChange = (e) => {
        const { id, value, files } = e.target;

        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));

    };

    useEffect(() => {
        setIsLoading(true);
        fetchStudents().finally(() => setIsLoading(false));
    }, []);

    const formatDate1 = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const handleEditClick = (student_id) => {
        const studentToEdit = students.find(student => student.student_id === student_id);
        if (studentToEdit) {
            navigate("/addstudent", {
                state: {
                    userData: studentToEdit,
                    imgName: studentToEdit.passport_size_photo
                },
            });
        } else {
            console.error(`Student with ID ${student_id} not found.`);
        }
    };

    const handleViewClick = (student_id) => {
        const studentToEdit = students.find(student => student.student_id === student_id);
        if (studentToEdit) {
            navigate("/viewstudents", {
                state: {
                    userData: studentToEdit,
                },
            });
        } else {
            console.error(`Student with ID ${student_id} not found.`);
        }
    };


    const columns = [
        {
            field: "student_id",
            headerName: "Student ID",
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        {
            field: "passport_size_photo",
            headerName: "Image",
            renderCell: () => null, // Hidden column but required for future use
            sortable: true,
            hide: true,
        },
        {
            field: "admission_number",
            headerName: "Admission Number",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        {
            field: "student_last_name",
            headerName: "Surname",
            renderCell: (params) => {
                const value = params.value || "";
                return (
                    <Tooltip title={value}>
                        <span>{value.length > 12 ? value.substring(0, 12) + "..." : value}</span>
                    </Tooltip>
                );
            },
            sortable: true,
        },
        {
            field: "student_first_name",
            headerName: "First Name",
            renderCell: (params) => {
                const value = params.value || "";
                return (
                    <Tooltip title={value}>
                        <span>{value.length > 12 ? value.substring(0, 12) + ".." : value}</span>
                    </Tooltip>
                );
            },
            sortable: true,
        },
        {
            field: "roll_no",
            headerName: "Roll Number",
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        {
            field: "date_of_join",
            headerName: "DOJ",
            renderCell: (params) => {
                const formattedDate = formatDate1(params.value);
                return (
                    <Tooltip title={formattedDate}>
                        <span>{formattedDate}</span>
                    </Tooltip>
                );
            },
            sortable: true,
        },
        {
            field: "class_name",
            headerName: "Class",
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        {
            field: "section_name",
            headerName: "Section",
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        {
            field: "student_class_teacher_name",
            headerName: "Class Teacher",
            renderCell: (params) => {
                const value = params.value || "";
                return (
                    <Tooltip title={value}>
                        <span>{value.length > 15 ? value.substring(0, 15) + "..." : value}</span>
                    </Tooltip>
                );
            },
            sortable: true,
        },
        {
            field: "gender",
            headerName: "Gender",
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        {
            field: "status",
            headerName: "Status",
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
            sortable: true,
        },
        ...(canSubmit
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    width: 150,
                    headerAlign: "center",
                    align: "center",
                    sortable: false,
                    renderCell: (params) => (
                        <div className="tableActions">
                            {canSubmit && Admin && (
                                <Tooltip title="Edit" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleEditClick(params.row.student_id)}
                                    >
                                        <MdEdit />
                                    </span>
                                </Tooltip>
                            )}
                            <Tooltip title="View" arrow>
                                <span
                                    className="commonActionIcons"
                                    onClick={() => handleViewClick(params.row.student_id)}
                                >
                                    <MdRemoveRedEye />
                                </span>
                            </Tooltip>
                            {canSubmit && (
                                <Tooltip title="Delete" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleDeleteClick(params.row.student_id)}
                                    >
                                        <MdExitToApp />
                                    </span>
                                </Tooltip>
                            )}
                        </div>
                    ),
                },
            ]
            : []),
    ];


    const fmt = (n) => {
        const num = Number(n ?? 0);
        return num.toLocaleString('en-IN', { maximumFractionDigits: 2 });
    };

    const [showExitForm, setShowExitForm] = useState(false)
    const handleDeleteClick = async (student_id) => {
        try {
            if (exitstudent.length === 0) {
                fetchExitStudent();
            }
            // setTermSummary([]);
            const studentToEdit = (students || []).find(student => student.student_id === student_id);

            if (studentToEdit) {
                setForm(studentToEdit);
                fetchStudentFeeSchedule(student_id);


                // Load already uploaded files (comma-separated string) into array
                if (studentToEdit.document) {
                    const filesArray = studentToEdit.document.split(',').map(f => f.trim()).filter(Boolean);
                    setUploadedFileNames(filesArray);
                } else {
                    setUploadedFileNames([]); // clear if no document
                }

                setShowExitForm(true);
            } else {
                console.error("Student not found.");
            }
        } catch (error) {
            console.error("Failed to fetch student details", error);
            alert("Error fetching student data");
        }
    };

    const searchableColumns = [
        (row) => row.student_id,
        (row) => row.admission_number,
        (row) => row.student_first_name,
        (row) => row.student_last_name,
        (row) => row.roll_no,
        (row) => formatDate1(row.date_of_join),
        (row) => row.class_name,
        (row) => row.section_name,
        (row) => row.student_class_teacher_name,
        (row) => row.gender,
        (row) => row.status,
    ];

    const filteredRecords = (students || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toLowerCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toLowerCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const [filter, setFilter] = useState({
        student_first_name: "",
        student_last_name: "",
        class_id: 0,
        section_id: 0,
        admission_number: "",
        student_class_teacher_id: 0,
        gender: "",
        date_of_join: "",
        academic_year_id: userObj.academic_year_id,
        school_id: userObj.school_id,
        action: "FILTER",
    });

    useEffect(() => {
        if (filter.class_id != 0) {
            fetchSections(filter.class_id || 0);
        }
        else {
            setSections([]);
        }
    }, [filter.class_id]);

    const handleFilterSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            student_first_name: filter.student_first_name || "",
            student_last_name: filter.student_last_name || "",
            class_id: filter.class_id || 0,
            section_id: filter.section_id || 0,
            admission_number: filter.admission_number || "",
            student_class_teacher_id: filter.student_class_teacher_id || 0,
            gender: filter.gender || "",
            date_of_join: filter.date_of_join || "",
            academic_year_id: filter.academic_year_id,
            school_id: userObj.school_id,
            action: "FILTER",
        };
        try {
            const response = await axios.post(baseUrl + "/students/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            setStudents(response.data || []);
            handleCloseFilterModal();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        // }
    };

    const handleFileChange1 = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFile(files);


        const fileNames = files.map((file) => file.name).join(", ");
        setFileNamesString(fileNames);
    };

    const handleRemoveFile = (fileNameToRemove) => {
        setUploadedFileNames((prevFiles) => {
            const updatedFiles = (prevFiles || []).filter((fileName) => fileName !== fileNameToRemove);

            const updatedFileNamesString = updatedFiles.join(", ");
            setFileNamesString(updatedFileNamesString);

            return updatedFiles;
        });
    };

    const uploadLogo = async () => {
        if (!selectedFile || selectedFile.length === 0) {
            toast.error("Please select at least one file");
            return null;
        }

        const formData = new FormData();
        selectedFile.forEach((file) => {
            formData.append("files", file);
        });

        try {
            const response = await axios.post(`${baseUrl}/uploads/multipleupload/`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            const uploadedFilePaths = response.data.uploaded_files.map((file) => file.location);
            return uploadedFilePaths;
        } catch (error) {
            console.error("Error uploading files:", error);
            toast.error("Error uploading files");
            return null;
        }
    };

    const resetForm = () => {
        setForm({
            student_id: "",
            date_of_exit: "",
            exit_type: "",
            document: "",
            exit_reason: "",
            which_school_student_has_gone: "",
            exit_status: "",
            school_id: userObj.school_id,
        });
        setSelectedFile(null);
        setFileNamesString("");
        setUploadedFileNames([]);
    };

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        if (!form.exit_type || !["A", "T", "Abscond", "Transfer"].includes(form.exit_type)) {
            toast.error("Please Enter Exit Type");
            return;
        }


        let uploadedFilePaths = form.document || [];

        if (uploadedFileNames.length > 0) {
            uploadedFilePaths = [...uploadedFileNames];
        }

        try {
            if (selectedFile && selectedFile.length > 0) {
                const newFilePaths = await uploadLogo();
                if (newFilePaths) {
                    uploadedFilePaths = [...uploadedFilePaths, ...newFilePaths];
                } else if (!uploadedFilePaths.length) {
                    toast.error("Error uploading files.");
                    return;
                }
            }
        } catch (error) {
            console.error("Error in uploadFiles:", error);
            toast.error("Error uploading files.");
            return;
        }

        const fileNamesOnly = (uploadedFilePaths).map(filePath => {
            return filePath.split(/[\\/]/).pop();
        });
        const approveStatus = { 'Abscond': 'A', 'Transfer': 'T' };
        const selectedStatus = approveStatus[form.exit_type] || form.exit_type;

        const formData = {
            student_id: form.student_id,
            date_of_exit: form.date_of_exit || "",
            exit_type: selectedStatus,
            document: fileNamesOnly.join(", "),
            exit_reason: form.exit_reason || "",
            which_school_student_has_gone: form.which_school_student_has_gone || "",
            exit_status: form.exit_status || "P",
            school_id: userObj.school_id,
            action: "UPDATE"
        };
        try {
            // console.log(formData);
            const response = await axios.post(baseUrl + "/exitstudent/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            // console.log("API Response", response.data)
            setExitStudent(response.data || []);
            toast.success("Sent for Approval");
            fetchStudents();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        resetForm();
        e.target.reset();
    };

    const handleFilterClear = async () => {
        setFilter({
            student_first_name: "",
            student_last_name: "",
            class_id: 0,
            section_id: 0,
            admission_number: "",
            student_class_teacher_id: 0,
            gender: "",
            date_of_join: "",
            academic_year_id: userObj.academic_year_id,
            action: "FILTER",
        });
        fetchStudents();
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <>

            <div className="pageBody">
                <ToastContainer />
                <div className="commonDataTableHead">
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <h6 className="commonTableTitle">Student Master</h6>
                        </div>
                        <div className="">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                className="searchInput mx-3"
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 6 }}>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                                <Button className="secondaryBtn" variant="Secondary" onClick={handleShowFilterModal}>
                                    <span><MdFilterList /></span>
                                </Button>
                            </OverlayTrigger>
                            {canSubmit && (
                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                                    <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addstudent")}>
                                        <span><MdAddCircle /></span>
                                    </Button>
                                </OverlayTrigger>


                            )}
                            {canSubmit && (
                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Bulk Update</Tooltip>}>
                                    <Button className="primaryBtn" variant="primary" onClick={() => navigate("/bulkupdate")}>
                                        <span><MdEdit /></span>
                                    </Button>
                                </OverlayTrigger>
                            )}

                        </div>


                    </div>
                </div>
                <div className="commonTable">
                    <div className="tableBody">
                        {isLoading ? (
                            <div className="loadingContainer">
                                <img src={loading} alt="Loading..." className="loadingGif" />
                            </div>
                        ) : (
                            <AppDataGrid
                                rows={filteredRecords}
                                columns={columns}
                                getRowId={(r) => r.student_id}
                                showToolbar={false}
                                pagination
                                pageSizeOptions={[10, 20, 50]}
                                density="compact"
                                maxHeight={600}
                            />
                        )}
                    </div>
                </div>
                <style>
                    {`
                .custom-dialog {
                    max-width: 95% !important;
                    width: 95% !important;
                }

                .custom-dialog .modal-content {
                    max-height: 90vh;
                    overflow-y: auto;
                }
                `}
                </style>


                <Modal show={showExitForm} onHide={() => setShowExitForm(false)} centered size="xl" style={{ maxWidth: "95%", width: "95%" }} dialogClassName="fixed-modal" >
                    <Modal.Header closeButton>
                        <Modal.Title>Student Exit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form id="ModalForm" onSubmit={handleModalSubmit}>
                            <Row className="px-3 pt-2">
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Student Name:</strong>
                                    <span>{form.student_last_name} {form.student_first_name}</span>
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "190px" }}>Admission Number:</strong>
                                    <span>{form.admission_number}</span>
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Class:</strong>
                                    <span>{form.class_name}</span>
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "190px" }}>Section:</strong>
                                    <span>{form.section_name}</span>
                                </Col>

                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Father:</strong>
                                    <span>{form.father_surname} {form.father_firstname}</span>
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "190px" }}>Mother:</strong>
                                    <span>{form.mother_surname} {form.mother_firstname}</span>
                                </Col>

                                {studentFeeSchedule.length > 0 && (
                                    <div style={{ marginTop: "5px" }}>

                                        {/* Summary above the table */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 16,
                                                justifyContent: "space-between",

                                                background: "#f8f9fa",
                                                borderRadius: 6,
                                                marginBottom: 8,
                                                fontWeight: 600
                                            }}
                                        >
                                            <div>Total Fee: {fmt(feeDetail?.total_fee)}</div>
                                            <div>Paid: {fmt(feeDetail?.total_paid)}</div>
                                            <div>Balance: {fmt(feeDetail?.balance)}</div>
                                        </div>

                                        <table className="receipt-table">
                                            <thead>
                                                <tr>
                                                    <th>Schedule Name</th>
                                                    <th style={{ textAlign: 'right' }}>Scheduled Amount</th>
                                                    <th style={{ textAlign: 'right' }}>Amount Paid</th>
                                                    <th style={{ textAlign: 'right' }}>Balance</th>
                                                    <th style={{ textAlign: 'center' }}>Due Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {studentFeeSchedule.map((item, index) => {
                                                    const isOverdue =
                                                        Number(item.balance_amount_to_be_paid) > 0 &&
                                                        new Date(item.due_date?.split("/").reverse().join("-")) < new Date();

                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                    <span style={{ paddingLeft: 10 }}>{item.schedule_name}</span>
                                                                    {Number(item.balance_amount_to_be_paid) === 0 && (
                                                                        <BsPatchCheckFill color="#28a745" size={18} title="Paid" />
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>{fmt(item.scheduled_amount)}</td>
                                                            <td style={{ textAlign: 'right' }}>{fmt(item.amount_paid)}</td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: isOverdue ? 'red' : 'inherit',
                                                                    fontWeight: isOverdue ? 600 : 'normal',
                                                                }}
                                                            >
                                                                {fmt(item.balance_amount_to_be_paid)}
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>{item.due_date}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                <Col md={6} className="mb-2 d-flex">
                                    <strong style={{ width: "160px" }}>Exit Type:</strong>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="radio"
                                            label="Abscond"
                                            disabled={
                                                form.exit_status?.toLowerCase() === "approved" ||
                                                form.exit_status?.toLowerCase() === "pending"
                                            }
                                            name="exitType"
                                            value="A"
                                            checked={form.exit_type === "A" || form.exit_type === "Abscond"}
                                            onChange={(e) => setForm({ ...form, exit_type: e.target.value })}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Transfer"
                                            name="exitType"
                                            disabled={
                                                form.exit_status?.toLowerCase() === "approved" ||
                                                form.exit_status?.toLowerCase() === "pending"
                                            }
                                            value="T"
                                            checked={form.exit_type === "T" || form.exit_type === "Transfer"}
                                            onChange={(e) => setForm({ ...form, exit_type: e.target.value })}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <div className="mb-2 d-flex align-items-center">
                                        <strong style={{ width: "160px" }}>Document:</strong>
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <input
                                                type="file"
                                                id="document"
                                                multiple
                                                onChange={handleFileChange1}
                                                disabled={
                                                    form.exit_status?.toLowerCase() === "approved" ||
                                                    form.exit_status?.toLowerCase() === "pending"
                                                }
                                                accept="image/*,application/pdf"
                                                style={{
                                                    flex: 1,
                                                    padding: "6px",
                                                    fontSize: "14px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <Button
                                                variant="primary"
                                                disabled={
                                                    form.exit_status?.toLowerCase() === "approved" ||
                                                    form.exit_status?.toLowerCase() === "pending"
                                                }
                                                style={{ padding: "6px 12px", fontSize: "14px" }}
                                                onClick={async () => {
                                                    if (selectedFile && selectedFile.length > 0) {
                                                        const newFilePaths = await uploadLogo();
                                                        if (newFilePaths) {
                                                            setUploadedFileNames((prev) => [...prev, ...newFilePaths]);
                                                            setSelectedFile(null);
                                                        }
                                                    } else {
                                                        toast.error("Please select at least one file");
                                                    }
                                                }}
                                            >
                                                Upload
                                            </Button>
                                        </div>
                                    </div>

                                    {/* Uploaded Files block */}
                                    <div className="commonInput">
                                        {uploadedFileNames.length > 0 && (
                                            <div>
                                                <p>Uploaded Files:</p>
                                                <table
                                                    className="table table-bordered"
                                                    style={{ fontSize: "14px", width: "100%", minWidth: "0px" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <td style={{ width: "70%" }}>File Name</td>
                                                            <td style={{ width: "30%" }}>Actions</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {uploadedFileNames.map((fileName, index) => {
                                                            const cleanFileName = fileName.trim().split(/[\\/]/).pop();

                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <a
                                                                            href={`${baseUrl}/uploads/get-image/${encodeURIComponent(
                                                                                cleanFileName
                                                                            )}`}
                                                                            download={cleanFileName}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{ fontSize: "12px" }}
                                                                        >
                                                                            {cleanFileName}
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        {form.exit_status?.toLowerCase() !== "pending" && form.exit_status?.toLowerCase() !== "approved" ? (
                                                                            <span
                                                                                style={{ cursor: "pointer", color: "red", fontSize: "16px" }}
                                                                                onClick={() => handleRemoveFile(fileName)}
                                                                            >
                                                                                ✖
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ color: "#aaa", fontSize: "16px", cursor: "not-allowed" }}>
                                                                                ✖
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </Col>

                                {/* Moved Next School below Uploaded Files and aligned left */}
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Next School:</strong>
                                    <Form.Control
                                        type="text"
                                        id="which_school_student_has_gone"
                                        disabled={
                                            form.exit_status?.toLowerCase() === "approved" ||
                                            form.exit_status?.toLowerCase() === "pending"
                                        }
                                        value={form.which_school_student_has_gone}
                                        placeholder="Enter School Name"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        maxLength={255}
                                        style={{ flex: 1 }}
                                    />
                                </Col>

                                <Col md={6} className="mb-2 d-flex">
                                    <strong style={{ width: "160px" }}>Comments:</strong>
                                    <Form.Control
                                        as="textarea"
                                        value={form.exit_reason}
                                        disabled={
                                            form.exit_status?.toLowerCase() === "approved" ||
                                            form.exit_status?.toLowerCase() === "pending"
                                        }
                                        placeholder="Enter Comments"
                                        onChange={(e) => setForm({ ...form, exit_reason: e.target.value })}
                                        maxLength={250}
                                        style={{ flex: 1 }}
                                    />
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Date of Exit:</strong>
                                    <Form.Control
                                        type="date"
                                        id="date_of_exit"
                                        value={form.date_of_exit}
                                        disabled={
                                            form.exit_status?.toLowerCase() === "approved" ||
                                            form.exit_status?.toLowerCase() === "pending"
                                        }
                                        onChange={handleInputChange}
                                        style={{ maxWidth: "300px" }}
                                    />
                                </Col>
                                <Col md={6} className="mb-2 d-flex align-items-center">
                                    <strong style={{ width: "160px" }}>Exit Status:</strong>
                                    <span>{form.exit_status}</span>
                                </Col>
                                {form.exit_status === "Rejected" && (
                                    <Col md={6} className="mb-2 d-flex align-items-center">
                                        <strong style={{ width: "190px" }}>Principal Comments:</strong>
                                        <span>{form.comments}</span>
                                    </Col>
                                )}
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowExitForm(false)}>
                            Cancel
                        </Button>
                        {form.exit_status !== "Approved" && form.exit_status !== "Pending" && (
                            <Button type="submit" variant="primary" form="ModalForm" onClick={handleClosePopupModal}>
                                Submit
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>

                <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                    <Modal.Header closeButton className="modalHeaderFixed">
                        <Modal.Title>Filter</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modalBodyScrollable">
                        <Form id="filterForm" onSubmit={handleFilterSubmit}>
                            <Row>
                                <Col xs={12}>
                                    <div className="commonInput">
                                        <Form.Group controlId="academic_year_id">
                                            <Form.Label>Academic Year</Form.Label>
                                            <Form.Select
                                                as="select"
                                                className="custom-select"
                                                value={filter.academic_year_id}
                                                onChange={(e) =>
                                                    setFilter({ ...filter, academic_year_id: parseInt(e.target.value) })
                                                }
                                            >
                                                <option value="" disabled hidden>Select Academic Year</option>
                                                {(academicYears || []).map((year) => (
                                                    <option key={year.academic_year_id} value={year.academic_year_id}>
                                                        {year.academic_year_name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group controlId="firstName">
                                            <Form.Label>Admission Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="admission_number"
                                                placeholder="Enter Admission Number"
                                                value={filter.admission_number}
                                                maxLength={30}
                                                onChange={(e) => setFilter({ ...filter, admission_number: e.target.value.trim() })}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group controlId="surName">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="student_first_name"
                                                placeholder="Enter First Name"
                                                value={filter.student_first_name}
                                                maxLength={30}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFilter({ ...filter, student_first_name: value });
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group controlId="surName">
                                            <Form.Label>Surname</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="surName"
                                                placeholder="Enter Surname"
                                                value={filter.student_last_name}
                                                maxLength={30}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFilter({ ...filter, student_last_name: value });
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group controlId="surName">
                                            <Form.Label>DOJ</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="doj"
                                                value={filter.date_of_join}
                                                onChange={(e) => setFilter({ ...filter, date_of_join: e.target.value.trim() })}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label> Class </Form.Label>
                                            <select
                                                type="number"
                                                className="form-select"
                                                id="class_id"
                                                value={filter.class_id}
                                                onChange={(e) => setFilter({ ...filter, class_id: e.target.value })}
                                            >
                                                <option value="0" disabled hidden>Select Class</option>
                                                {(classes || [])
                                                    .filter((classItem) => classItem.is_active === "Active") // Filter to include only active classes
                                                    .map((classItem) => (
                                                        <option key={classItem.class_id} value={classItem.class_id}>
                                                            {classItem.class_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>Section</Form.Label>
                                            <select
                                                className="form-select"
                                                id="section_id"
                                                value={filter.section_id}
                                                onChange={(e) => setFilter({ ...filter, section_id: e.target.value })}
                                            >
                                                <option value="0" disabled hidden>Select Section</option>
                                                {(sections || []).map((section, index) => (
                                                    <option key={index} value={section.section_id}>
                                                        {section.section_name}
                                                    </option>
                                                ))}
                                            </select>
                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12}>
                                    <div className='commonInput'>
                                        <Form.Group>
                                            <Form.Label>Class Teacher</Form.Label>
                                            <select
                                                className="form-select"
                                                id="student_class_teacher_id"
                                                value={filter.student_class_teacher_id}
                                                onChange={(e) => setFilter({ ...filter, student_class_teacher_id: e.target.value })}
                                            >
                                                <option value="0" disabled hidden>Select Class Teacher</option>
                                                {(users || []).map((users) => (
                                                    <option key={users.userid} value={users.userid}>
                                                        {users.surname + " " + users.firstname}
                                                    </option>
                                                ))}
                                            </select>
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12} >
                                    <div className='commonInput'>
                                        <Form.Group controlId="is_current_year">
                                            <Form.Label>Gender</Form.Label>
                                            <Form.Select
                                                type="text"
                                                name="gender"
                                                value={filter.gender}
                                                onChange={(e) => setFilter({ ...filter, gender: e.target.value })}
                                            >
                                                <option value="" disabled hidden>Select Gender</option>
                                                <option value="M">Male</option>
                                                <option value="F">Female</option>
                                            </Form.Select>
                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="modalFooterFixed">
                        <Button
                            variant="secondary"
                            className="btn-info clearBtn"
                            onClick={handleFilterClear}
                        >
                            Reset
                        </Button>

                        <div className="">
                            <Button variant="secondary" className="btn-danger secondaryBtn"
                                onClick={() => { handleCloseFilterModal(); }}>
                                Cancel
                            </Button>
                            <Button variant="primary" type="submit" className="btn-success primaryBtn" form="filterForm" onClick={handleCloseFilterModal}>
                                Search
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>



        </>
    );
};

export default Students;
